import { ResourceService } from './../../../data/services/resource'
import { Resource } from './../../../data/models/resource'
import { IDataServiceConfig, ModelRepository } from '../../../model-repository'
import { ResourceType } from '../../../data/models/resource/resource-type'

export const ResourceConfig: IDataServiceConfig<Resource> = {
  service: ResourceService,
  deps: [ModelRepository],
  endpoint: 'resources?filter[user-id]=:user_id',
  model: Resource,
  presenter: null,
  backend: 'cached',
  mappings: [
    {
      classType: 'Resource',
      jsonType: 'resources',
      propertyMapping: {
        resourceType: {
          transform: {
            toModel: (resourceType): ResourceType => {
              const pascalCase = (input) => {
                const r = input.replace(/[-_ ](.)/g, (_match, group1) => group1.toUpperCase())
                return r.substring(0, 1).toUpperCase() + r.substring(1)
              }

              const stringAsEnum = (typeof resourceType === 'string') ? ResourceType[pascalCase(resourceType)] : undefined
              return (
                typeof stringAsEnum !== 'undefined' ? stringAsEnum : ResourceType.Unknown
              ) as ResourceType
            }
          }
        }
      }
    }
  ]

}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/config/services/data/resource.config.ts